import React from 'react';
import { UserIcon } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  city: string;
  occupation: string;
  quote: string;
}
export function Testimonial({
  name,
  age,
  city,
  occupation,
  quote
}: TestimonialProps) {
  return <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-orange-500" data-id="element-341">
      <div className="flex items-start gap-4" data-id="element-342">
        <div className="bg-gray-200 rounded-full p-3 flex-shrink-0" data-id="element-343">
          <UserIcon className="w-8 h-8 text-gray-600" data-id="element-344" />
        </div>
        <div className="flex-1" data-id="element-345">
          <div className="mb-3" data-id="element-346">
            <p className="font-bold text-gray-900 text-lg" data-id="element-347">
              {name}, {age} años
            </p>
            <p className="text-gray-600 text-sm" data-id="element-348">
              {city} • {occupation}
            </p>
          </div>
          <p className="text-gray-700 italic leading-relaxed" data-id="element-349">"{quote}"</p>
        </div>
      </div>
    </div>;
}